import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { LineItemSelector, Text, UnexpectedReturnChip } from '@reveni-io/reveni-ui'

import OrderSelector from '@/returns/components/OrderSelector/OrderSelector'

import * as Styles from './styles'

const ReviewItem = ({ item, index, onLink, onDiscard }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const handleLink = order => onLink(item.id, order)

  const handleDiscard = () => onDiscard(item.id)

  return (
    <Styles.Container>
      <Styles.Header>
        <Text type="allCapsM">{`${t('Producto')} #${index}`}</Text>
        <UnexpectedReturnChip />
      </Styles.Header>
      <LineItemSelector
        lineItem={item}
        showToggle={false}
        showIndex={false}
        customStyles={{ padding: 0, paddingBottom: theme.spacing.sp16 }}
      />
      <OrderSelector
        orders={item.available_orders}
        decision={item.decision}
        onLink={handleLink}
        onDiscard={handleDiscard}
      />
    </Styles.Container>
  )
}

export default ReviewItem
